import { StoreHoursInfo, StoreHoursInfoDetails } from '../../common';
import { DealerStore } from '../dealerStoreType';
import { CLOSED, OPEN_24_HOURS } from '../constants';
import styles from '../DealerLocator.module.scss';

interface DealerLocatorStoreHoursInfoProps {
  storeHoursOpen24HrsTitle: string;
  storeHoursTitle: string;
  store: DealerStore;
  isStoreLocationOptimizationFlag?: boolean;
}

export const DealerLocatorStoreHoursInfo = ({
  storeHoursOpen24HrsTitle,
  storeHoursTitle,
  store,
  isStoreLocationOptimizationFlag
}: DealerLocatorStoreHoursInfoProps) => {
  const { storeHours = [] } = store;
  const sortedStoreHours = [...storeHours].sort((a, b) => a.index - b.index);
  const storeHoursDetails =
    sortedStoreHours.map((element) => {
      return (
        <StoreHoursInfoDetails
          key={element.label}
          storeHoursInfoDetails={element}
        />
      );
    }) || null;
  const isStoreClosed = storeHours.every((elem) => elem.value === CLOSED);
  const isStoreAvailable24Hrs = storeHours.every(
    (elem) => elem.value === OPEN_24_HOURS
  );
  return (
    <div className={`d-flex flex-column order-lg-2 ${styles['resp-width']}`}>
      <StoreHoursInfo
        title={storeHoursTitle}
        open24HoursTitle={storeHoursOpen24HrsTitle}
        isStoreAvailable24Hrs={isStoreAvailable24Hrs}
        isStoreClosed={isStoreClosed}
        isStoreLocationOptimizationFlag={isStoreLocationOptimizationFlag}
      >
        <div className={'mt-2'}>{storeHoursDetails}</div>
      </StoreHoursInfo>
    </div>
  );
};
